import { render, staticRenderFns } from "./MobilephoneConfirm.vue?vue&type=template&id=230a2c2a&scoped=true&"
import script from "./MobilephoneConfirm.vue?vue&type=script&lang=js&"
export * from "./MobilephoneConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MobilephoneConfirm.vue?vue&type=style&index=0&id=230a2c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a2c2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VForm,VTextField})
